import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { Channel, GoonAPIClient } from '../client/ApiClient';
import { API_ENDPOINT } from '../constants';

@customElement('channel-list')
export class ChannelList extends LitElement {
  createRenderRoot() { return this; }
  @state() channels: Channel[] = [];

  async connectedCallback() {
    super.connectedCallback();
    const api = new GoonAPIClient(API_ENDPOINT);
    this.channels = await api.listChannels();
  }

  render() {
    return html`
      <div class="bg-base-100 min-h-screen flex flex-col">
        <div class="flex flex-col lg:flex-row gap-6 px-4 sm:px-6 py-6 mx-auto w-full">
          <main class="w-full lg:w-4/6 flex flex-col gap-6">
            ${this.channels.map(channel => html`
              <channel-preview .channelslug=${channel.slug}></channel-preview>
            `)}
          </main>
          <aside class="w-full lg:w-2/6">
            <div class="sticky top-20">
              <realtime-chat></realtime-chat>
            </div>
          </aside>
        </div>
      </div>
    `;
  }
}
